export async function fetchAllRows(makeQuery, pageSize = 1000) {
  const rows = [];
  for (let offset = 0; ; offset += pageSize) {
    const { data, error } = await makeQuery()
      .order("id", { ascending: true })
      .range(offset, offset + pageSize - 1);
    if (error) throw error;
    rows.push(...(data || []));
    if (!data || data.length < pageSize) return rows;
  }
}

export function summarizeCurrencyAmounts(rows, amountKey = "amount") {
  return rows.reduce((totals, row) => {
    const currency = row.currency?.trim().toUpperCase() || "UNKNOWN";
    totals[currency] = (totals[currency] || 0) + Number(row[amountKey] || 0);
    return totals;
  }, {});
}

export function formatRevenueTotals(totals = {}) {
  const entries = Object.entries(totals).sort(([a], [b]) => a.localeCompare(b));
  return entries.length ? entries.map(([currency, amount]) =>
    currency === "UNKNOWN"
      ? `${Number(amount).toLocaleString(undefined, { maximumFractionDigits: 2 })} (currency unknown)`
      : new Intl.NumberFormat(undefined, {
          style: "currency", currency, currencyDisplay: "code",
        }).format(amount),
  ).join(" · ") : "0";
}

export function summarizeLearnerProgress(enrollments, progress, startDate) {
  const eligible = enrollments.filter((row) =>
    ["active", "completed"].includes(row.enrollment_status),
  );
  const ids = new Set(eligible.map((row) => row.id));
  const users = new Set(eligible.map((row) => row.user_id));
  const activity = progress.filter((row) => ids.has(row.enrollment_id) && users.has(row.user_id));
  const active = new Set([
    ...eligible.filter((row) => new Date(row.enrolled_at) >= new Date(startDate)).map((row) => row.user_id),
    ...activity.filter((row) => new Date(row.last_accessed_at) >= new Date(startDate)).map((row) => row.user_id),
  ]);
  const completed = eligible.filter((row) => row.enrollment_status === "completed").length;
  return {
    total_students: users.size,
    active_students: active.size,
    completed_courses: completed,
    completion_rate: eligible.length ? Math.round(completed / eligible.length * 100) : 0,
    monthly_active_percentage: users.size ? Math.round(active.size / users.size * 100) : 0,
    // The source stores cumulative lesson time, so this is explicitly lifetime.
    avg_study_hours: users.size
      ? Math.round(activity.reduce((sum, row) => sum + Number(row.time_spent_minutes || 0), 0) / 60 / users.size * 10) / 10
      : 0,
  };
}
